import { NgModule } from '@angular/core';
import { AppImComponent } from './app-im.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { EmojiPickerComponent } from './emoji-picker/emoji-picker.component';
import { TextElementComponent } from './message/text-element/text-element.component';
import { UploadPickerComponent } from './upload-picker/upload-picker.component';
import { ImageElementComponent } from './message/image-element/image-element.component';
import { LiveElementComponent } from './message/live-element/live-element.component';
import { LiveRoomComponent } from './live-room/live-room.component';
import { RECRangeComponent } from './REC-range/REC-Rangecomponent';
import { CommonModule } from '@angular/common';
import { FileElementComponent } from './message/file-element/file-element.component';
import { FilePreviewComponent } from './file-preview/file-preview.component';
 


@NgModule({
  imports: [
      SharedModule,
      CommonModule
    
  ],
  declarations: [
    AppImComponent,
    EmojiPickerComponent,
    TextElementComponent,
    UploadPickerComponent,
    ImageElementComponent,
    LiveElementComponent,
    LiveRoomComponent,
    RECRangeComponent,
    FileElementComponent,
    FilePreviewComponent
  ],
  exports: [
    AppImComponent,
    EmojiPickerComponent,
    TextElementComponent,
    UploadPickerComponent,
    ImageElementComponent,
    LiveElementComponent,
    LiveRoomComponent,
    RECRangeComponent
  ]
})
export class ChatModule { }
